import { FC, ReactElement } from "react";

import { PageHeader } from "@/components";

const RiskAndTrends: FC = (): ReactElement => {
  return <PageHeader title={"RiskAndTrends"} />;
};

export default RiskAndTrends;
